import { useEffect, useState } from 'react'
import { getBlob } from '../api/client.ts'

/**
 * Miniatura de la foto de prueba de una tarea.
 *
 * La imagen no se pide con <img src>: el endpoint exige sesión y una etiqueta
 * img no manda la cabecera Authorization. Se descarga con fetch y se muestra
 * desde una URL de objeto, que se libera al desmontar.
 */
export function PhotoThumb({ instanceId, alt }: { instanceId: string; alt: string }) {
  const [url, setUrl] = useState<string | null>(null)
  const [failed, setFailed] = useState(false)
  const [zoom, setZoom] = useState(false)

  useEffect(() => {
    let objectUrl: string | null = null
    let cancelled = false

    void getBlob(`/api/instances/${instanceId}/photo`)
      .then((blob) => {
        if (cancelled) return
        objectUrl = URL.createObjectURL(blob)
        setUrl(objectUrl)
      })
      .catch(() => {
        if (!cancelled) setFailed(true)
      })

    return () => {
      cancelled = true
      if (objectUrl) URL.revokeObjectURL(objectUrl)
    }
  }, [instanceId])

  if (failed) {
    return <span className="text-xs text-[var(--color-muted)]">Foto no disponible</span>
  }

  if (!url) {
    return <div className="h-16 w-16 animate-pulse rounded-lg bg-[var(--color-line)]" />
  }

  return (
    <>
      <button onClick={() => setZoom(true)} aria-label={`Ampliar foto de ${alt}`}>
        <img
          src={url}
          alt={alt}
          className="h-16 w-16 rounded-lg border border-[var(--color-line)] object-cover"
        />
      </button>

      {zoom && (
        <div
          onClick={() => setZoom(false)}
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/85 p-4"
        >
          <img src={url} alt={alt} className="max-h-full max-w-full rounded-xl object-contain" />
        </div>
      )}
    </>
  )
}
